import { React } from 'Imports';
import { WidgetTooltip } from '$Components/Shared/WidgetTooltip';

const styles = require('./DashboardTooltip.scss') as {
    iconPlacement: string;
};

interface IDashboardTooltipProps {
    prompt: string
    description: React.ReactElement;
}

type DashboardTooltiprops = IDashboardTooltipProps;

export const DashboardTooltip = (props: DashboardTooltiprops) => {
    
    return (
        <div className={styles.iconPlacement}>
            <WidgetTooltip
                    prompt={props.prompt}
                    description={props.description}
                    contentPosition='bottomRight'
            />
        </div>
    );
};
